import { apiService } from '../../shared/services/apiService';
import { ChallengePaymentInfo } from '../interfaces/challengePaymentInfo';
import { CurrentSubscriptionInfo } from '../interfaces/customerSubscription';
import { PromoCodeInfo } from '../interfaces/promoCodeInfo';

type ApplyPromoCodeResponse = {
  challengeSetup: ChallengePaymentInfo;
  promocode: PromoCodeInfo;
};

type GetChallengePaymentInfoResponse = {
  challengeSetup: ChallengePaymentInfo;
  promocode: PromoCodeInfo | null;
};

export const challengePaymentService = {
  async getChallengePaymentInfo(
    participantId: number,
  ): Promise<GetChallengePaymentInfoResponse> {
    const response = await apiService.get(
      `/api/challenge/participant/${participantId}/challenge-data`,
    );

    return response.data;
  },

  async applyPromoCode(
    participantId: number,
    promocode: string,
  ): Promise<ApplyPromoCodeResponse> {
    const response = await apiService.post<ApplyPromoCodeResponse>(
      `/api/challenge/participant/${participantId}/apply-promo`,
      { promocode },
    );

    return response.data;
  },

  async getNutritionSubscriptionInfo(
    participantId: number,
  ): Promise<CurrentSubscriptionInfo> {
    const response = await apiService.get(
      `/api/challenge/participant/${participantId}/subscription/nutrition`,
    );

    return response.data;
  },
};
